import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faArrowUp, faChevronUp, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ItemRss } from 'app/shared/models/itemRss/itemRss';
import { Menu } from 'app/shared/models/Menus/menus';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { SearchFilterService } from 'app/shared/services/search-filter/search-filter.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-flux-rss',
  templateUrl: './flux-rss.component.html',
  styleUrls: ['./flux-rss.component.scss']
})
export class FluxRssComponent extends SubscriptionBaseComponent implements OnInit {

  faSearch = faSearch;
  faArrowUp = faArrowUp;
  faTimes = faTimes;
  faChevronUp = faChevronUp;


  menu: Menu;

  searchForm: FormGroup;
  valueInput: string;

  itemsFlux: ItemRss[] = [];
  itemsFluxFilter = [];

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private filterService: SearchFilterService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private titleService: TitleService,
    private authenticationService: AuthenticationService


  ) {
    super();
  }

  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    this.titleService.title.next(this.route.snapshot.params.name);
    this.initForm();
    this.initSub();
    this.getAllMenu();
  }

  scrollToElement(): void {
    document.querySelector('#target').scrollIntoView({ behavior: 'smooth' });

    // $element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  applyFilter(filterValue: string): void {

    this.valueInput = filterValue;
    this.itemsFluxFilter = [];
    this.filterFlux(filterValue);
    this.resetFlux(this.itemsFlux);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.applyFilter('');
  }

  private getAllMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.getSingleMenu(res);
    });
  }

  private getSingleMenu(list: Menu[]): void {
    const menuName = this.route.snapshot.params.name;
    list.forEach(item => {
      if (item.lien === menuName) {
        this.menu = item;
      }
    });

    this.getFluxRss(this.menu?.title_Home);
  }

  private getFluxRss(title: string): void {
    this.userService.getFluxRss(title).subscribe(res => {
      this.itemsFlux = res;
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private get f(): object {
    return this.searchForm.controls;
  }

  private resetFlux(flux: any): void {
    this.itemsFlux = flux;
  }

  private filterFlux(filterValue: string): void {
    this.itemsFluxFilter = this.filterService.filter(this.itemsFlux, filterValue);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.keyword.asObservable().subscribe(kw => {
          this.searchForm.get('keyword').setValue(kw);
          this.applyFilter(kw);
          this.cdr.detectChanges();
        })
      );
  }

}
